import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChildrenRowsTitle } from "../../../../Constant";
import { CHILD_ROW_COLUMN, CHILD_ROW_DATA } from "../../../../Data/DataTable/ChildRowsData";
import { ZERO_CONFIGURATION_DATA } from "../../../../Data/DataTable/ZeroConfiguration";
import CustomExpandableComponent from "./CustomExpandableComponent";

const ChildRows = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={ChildrenRowsTitle} span={CHILD_ROW_DATA} />
        <CardBody>
          <div className="table-responsive">
            <div id="API-chield-row" >
              <DataTable data={ZERO_CONFIGURATION_DATA} columns={CHILD_ROW_COLUMN} pagination expandableRows expandableRowsComponent={CustomExpandableComponent} striped  highlightOnHover className="display"/>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ChildRows;
